// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const pt: KnowledgePagesCopy = {
  knowledgePage: 'Página de conhecimento',
  knowledgePages: 'Páginas de conhecimento',
  featureOffTitle: 'As páginas de conhecimento não estão ativadas neste espaço de trabalho.',
  featureOffBody: 'O contexto da empresa e as fontes continuam em Conhecimento.',
  loadingPage: 'A carregar a página…',
  loadingSuggestion: 'A carregar a sugestão…',
  cancel: 'Cancelar',
  tryAgain: 'Tentar novamente',
  everyoneIn: 'Todos em {company}',
  yourCompany: 'a sua empresa',
  revision: 'Revisão {n}',
  openRevision: 'Abrir a revisão {n}',
  pageCount: 'one:página|other:páginas',
  topicCount: 'one:tema|other:temas',
  sectionCount: 'one:secção|other:secções',
  lineCount: 'one:linha|other:linhas',
  documentCount: 'one:documento|other:documentos',
  changeCount: 'one:alteração|other:alterações',
  newPageCount: 'one:página nova|other:páginas novas',
  changedPageCount: 'one:página alterada|other:páginas alteradas',
  otherSectionCount: 'one:outra secção|other:outras secções',
  characterCount: 'one:carácter|other:caracteres',
  diffStats: '{sections} alteradas · {added} adicionadas · {removed} removidas',
  diffMatchesBase: 'O texto proposto coincide com a revisão de base.',
  diffIntroduction: 'Introdução',
  diffOtherUnchanged: '{sections} sem alterações.',
  timeJustNow: 'agora mesmo',
  originImportedFrom: 'Importado de {path}',
  originImportedFromCommit: 'Importado de {path} @ {commit}',
  authorityApprovedInPoneva: 'Aprovado no Poneva',
  authorityImported: 'Importado',
  authorityInRepository: '{canonicality} no repositório',
  authorityVerified: 'verificado a {date}',
  authorRepositoryImport: 'Importação do repositório',
  authorSuggestedInChat: 'Sugerido no chat',
  authorSuggestedInChatWith: 'Sugerido no chat com {name}',
  authorSuggestedBy: 'Sugerido por {name}',
  authorSuggestedByApp: 'Sugerido por uma app ligada',
  authorSuggestedByColleague: 'Sugerido por um colega',
  authorSuggestedByYou: 'Sugerido por si',
  authorSuggestedOnBehalf: 'Sugerido por {app} em nome de {name}',
  authorSuggestedByAppOnBehalf: 'Sugerido por uma app ligada em nome de {name}',
  authorSuggestedAndApproved: 'Sugerido e aprovado por {name}',
  approverApprovedBy: 'aprovado por {name}',
  approverAppliedBy: 'aplicado por {name}',
  kindCreatePage: 'Página nova',
  kindUpdatePage: 'Atualização proposta',
  kindArchivePage: 'Arquivo',
  statusConflict: 'Conflito · a página mudou',
  statusPending: 'A aguardar revisão',
  statusApproved: 'Aprovada',
  statusRejected: 'Descartada',
  statusWithdrawn: 'Retirada',
  statusSuperseded: 'Substituída',
  errRevisionConflict: 'Esta página mudou enquanto a estava a rever.',
  errProposalChanged:
    'Esta sugestão mudou enquanto a estava a rever. Reveja a versão mais recente antes de decidir.',
  errPublishRequired:
    'Só os publicadores da empresa podem aprovar alterações ao conhecimento ou importar páginas.',
  errProposalLimit:
    'A sua empresa já tem 200 sugestões a aguardar revisão. Reveja algumas antes de sugerir mais.',
  errAuthorLimit:
    'Já tem 50 sugestões a aguardar revisão. Aguarde que algumas sejam decididas, ou retire algumas, antes de sugerir mais.',
  errImportProposalLimit:
    'Esta importação acrescentaria mais páginas alteradas para revisão do que cabem na fila de revisão da sua empresa (200, no máximo). Decida algumas sugestões em Para rever e aplique novamente.',
  errImportChanged:
    'Esta importação não é a que reviu. Abra-a novamente e reveja-a antes de a aplicar.',
  errImportItemNotFound: 'Este documento já não faz parte da importação.',
  errIdempotencyConflict:
    'Esta sugestão já foi enviada com um conteúdo diferente. Recarregue e tente novamente.',
  errImportHashMismatch:
    'Um ficheiro deste snapshot não corresponde à soma de verificação registada. Crie o snapshot novamente e tente outra vez.',
  errImportAlreadyApplied: 'Esta importação já foi aplicada.',
  errImportDiscarded: 'Esta importação foi descartada. Escolha novamente o ficheiro do snapshot.',
  errImportDuplicateItem:
    'Este snapshot inclui o mesmo documento duas vezes. Crie o snapshot novamente.',
  errInvalidImport:
    'O Poneva não conseguiu aceitar este snapshot. Crie-o novamente com o script de snapshot e tente outra vez.',
  errInvalidInput:
    'O Poneva não conseguiu aceitar estes dados. Verifique os campos e tente novamente.',
  errImportLimit:
    'Há demasiadas importações preparadas mas não aplicadas. Aplique ou descarte algumas antes de preparar outra.',
  errPageTooLarge: 'Uma página tem mais de 256 KB. Divida-a em páginas mais pequenas.',
  errTooManySections: 'Uma página tem mais de 2000 títulos. Divida-a em páginas mais pequenas.',
  errPageLimit: 'A sua empresa atingiu o limite de 2000 páginas de conhecimento.',
  errCollectionLimit: 'A sua empresa atingiu o limite de 100 temas.',
  errProposalNotPending: 'Esta sugestão já foi decidida. O estado apresentado é o atual.',
  errRequesterRemoved:
    'A pessoa que sugeriu isto já não pertence a esta empresa, por isso não pode ser aprovado.',
  errRevisionAlreadyCurrent: 'Essa revisão já é a atual.',
  errPageArchived:
    'Esta página foi arquivada enquanto a estava a rever. Reveja a sugestão novamente antes de decidir.',
  errAlreadyArchived: 'Esta página já está arquivada.',
  errProposalForbidden: 'Só a pessoa que fez esta sugestão a pode retirar.',
  errUnavailable: 'As páginas de conhecimento não estão disponíveis neste momento.',
  errTimeout: 'O Poneva demorou demasiado a responder.',
  errItemTooLarge: '{path} tem mais de 256 KB. Divida-o em páginas mais pequenas.',
  errItemTooManySections: '{path} tem mais de 2000 títulos. Divida-o em páginas mais pequenas.',
  errItemHashMismatch:
    '{path} não corresponde à soma de verificação registada. Crie o snapshot novamente e tente outra vez.',
  errNoLongerAvailable: 'Este item já não está disponível para si.',
  errTooLargeToSend: 'Este ficheiro é demasiado grande para ser enviado.',
  cardChecking: 'A verificar o estado…',
  cardNotAvailable: 'Não disponível',
  cardStatusUnavailable: 'Estado indisponível',
  cardUnshowable: 'Não foi possível mostrar esta atualização de conhecimento sugerida.',
  cardEyebrow: 'Atualização de conhecimento sugerida',
  cardLabel: 'Atualização de conhecimento sugerida · {title}',
  cardMissing: 'Esta sugestão já não está disponível para si.',
  cardUnknown:
    'Não foi possível verificar o ponto de situação desta sugestão. Abra a revisão para ver o estado.',
  cardCheckAgain: 'Verificar novamente',
  cardReview: 'Rever atualização',
  statusLineApproved: 'Conhecimento aprovado',
  readyCount: 'one:pronto para pesquisa|other:prontos para pesquisa',
  preparingCount: 'one:em preparação|other:em preparação',
  attentionCount: 'one:requer atenção|other:requerem atenção',
  topicsExplore: 'Explorar um tema',
  topicsAllPages: 'Todas as páginas',
  topicsOpenPages: 'Abrir Páginas',
  topicsEmpty:
    'Ainda não há páginas aprovadas. As páginas guardam o conhecimento extenso da empresa com todo o histórico de revisões.',
  reviewsTitle: 'Atualizações de páginas sugeridas',
  reviewsTitleMine: 'As suas atualizações de páginas sugeridas',
  reviewsIntro:
    'Cada sugestão é uma revisão candidata completa, com o respetivo motivo e as provas. Nada muda até aprovar essa revisão exata.',
  reviewsIntroMine:
    'As suas sugestões aguardam aqui até que um publicador da empresa as reveja. Até lá, as páginas ficam como estão.',
  loadPagesFailed: 'Não foi possível carregar as páginas de conhecimento.',
  loadProposalsFailed: 'Não foi possível carregar as atualizações de páginas sugeridas.',
  loadMoreFailed: 'Não foi possível carregar mais páginas.',
  otherPages: 'Outras páginas',
  loadTopicFailed: 'Não foi possível carregar este tema.',
  revisionShort: 'r{n}',
  updatedOn: 'Atualizado a {date}',
  emptyTitle: 'Ainda não há páginas de conhecimento.',
  emptyBody:
    'As páginas guardam o conhecimento aprovado e extenso da sua empresa — orientação, decisões e formas de trabalhar — com todas as revisões preservadas. Importe a partir de um snapshot do repositório ou comece uma página no chat; um publicador aprova cada página antes de esta contar como conhecimento da empresa.',
  importFromSnapshot: 'Importar de um snapshot do repositório',
  startInChat: 'Começar uma página no chat',
  startInChatPrompt:
    'Ajude-me a começar uma página de conhecimento para a nossa empresa. Pergunte-me o que deve abranger e não invente conteúdo. Fica como sugestão até que um publicador da empresa a aprove.',
  loadingPages: 'A carregar as páginas de conhecimento…',
  filterLabel: 'Filtrar páginas por título',
  filterPlaceholder: 'Filtrar páginas',
  importButton: 'Importar',
  showingTopic: 'A mostrar {topic}',
  showAllTopics: 'Mostrar todos os temas',
  loadingTopic: 'A carregar este tema…',
  noMatch: 'Nenhuma página corresponde a «{filter}».',
  topicNoPages: 'Ainda não há páginas aprovadas neste tema.',
  loading: 'A carregar…',
  loadMore: 'Carregar mais páginas',
  metaApproved: 'aprovada a {date}',
  metaRepositoryAuthoritative: 'o repositório continua a ser a referência',
  loadPageFailed: 'Não foi possível carregar esta página.',
  loadHistoryFailed: 'Não foi possível carregar o histórico de revisões.',
  outlineLabel: 'Secções da página',
  outlineToggle: 'Nesta página',
  loadingHistory: 'A carregar o histórico de revisões…',
  historyLabel: 'Histórico de revisões',
  historyIntro:
    'Todas as revisões aprovadas são preservadas. Restaurar uma anterior cria uma sugestão para revisão; nunca apaga revisões posteriores.',
  historyCurrent: 'Atual',
  historyViewing: 'Em visualização',
  historyView: 'Ver',
  historyViewAria: 'Ver a revisão {n}',
  restoreAria: 'Restaurar como sugestão: revisão {n}',
  restoreCreating: 'A criar a sugestão…',
  restore: 'Restaurar como sugestão',
  restoreUnconfirmed:
    'Não foi possível confirmar que a sugestão foi criada. Verifique Para rever antes de tentar novamente.',
  editTooLarge:
    'Esta página tem mais de 256 KB. Divida-a em páginas mais pequenas antes de a sugerir.',
  editConflict:
    'Esta página mudou enquanto a estava a editar. Copie o seu texto, abra a revisão mais recente e sugira a edição novamente.',
  editUnconfirmed:
    'Não foi possível confirmar que a sua sugestão foi enviada. Verifique Para rever antes de a enviar novamente.',
  editHeading: 'Sugerir uma edição',
  editIntro:
    'Está a editar a revisão {n}. Um publicador da empresa revê a alteração exata antes de esta passar a ser a revisão {next}; até lá, a página fica como está.',
  editOutdated:
    'Foi aprovada uma revisão mais recente enquanto estava a editar. Copie o seu texto e recomece a partir da revisão mais recente para não perder nada do que ela alterou.',
  editContentLabel: 'Conteúdo da página (Markdown)',
  editReasonLabel: 'Porquê esta alteração?',
  editReasonPlaceholder: 'O que mudou e de onde vem.',
  editSending: 'A enviar…',
  editSend: 'Enviar para revisão',
  editDiscardConfirm: 'Descartar esta edição? Nada do que alterou foi enviado.',
  editNoChanges: 'Ainda não há alterações.',
  editNeedsContent: 'Uma página precisa de algum conteúdo.',
  exportFailed: 'Não foi possível exportar esta página. Tente novamente.',
  askPagePrompt: 'Pergunta sobre a página de conhecimento «{title}» (revisão {n}, {link}):',
  askPageSectionPrompt:
    'Pergunta sobre a página de conhecimento «{title}» § {section} (revisão {n}, {link}):',
  pageMissingTitle: 'Esta página não está disponível.',
  pageMissingBody:
    'Pode ter sido arquivada ou pode já não ter acesso ao conhecimento desta empresa.',
  pageArchived: 'Arquivada',
  viewingRevisionCurrent: 'Está a ver a revisão {n}; a revisão atual é a {current}.',
  viewingRevisionOld: 'Está a ver a revisão {n}. Não é a revisão atual.',
  openCurrent: 'Abrir a atual',
  archivedBanner:
    'Esta página está arquivada. Já não informa as respostas; o histórico é preservado.',
  pageViewsLabel: 'Vistas da página',
  tabRead: 'Ler',
  tabHistory: 'Histórico',
  unknownSection: 'A secção ligada não faz parte desta revisão. A mostrar a página inteira.',
  askAboutPage: 'Perguntar sobre esta página',
  exporting: 'A exportar…',
  exportMarkdown: 'Exportar Markdown',
  loadSuggestionFailed: 'Não foi possível carregar esta sugestão.',
  evidenceSource: 'Fonte',
  evidenceFact: 'Contexto da empresa',
  evidenceResult: 'Trabalho guardado',
  evidenceUrl: 'Página web',
  evidenceDecision: 'Decisão',
  evidenceReference: 'Referência',
  evidenceOpenPage: 'Abrir a página de conhecimento',
  evidenceOpenSource: 'Abrir a fonte',
  evidenceOpenFact: 'Abrir o contexto da empresa',
  evidenceOpenResult: 'Abrir o trabalho guardado',
  evidenceOpenUrl: 'Abrir a página web',
  evidenceOpenDecision: 'Abrir a decisão',
  evidenceOpenReference: 'Abrir a referência',
  evidenceDecisionNote: 'Uma decisão registada. Não há nada no Poneva para abrir.',
  evidenceFactGone: 'Este contexto da empresa já não está guardado.',
  evidencePageNoRevision: 'Esta página não tem nenhuma revisão aprovada para abrir.',
  evidencePrivateExcerpt: 'Prova privada — só foi partilhado o excerto acima.',
  evidencePrivate: 'Prova privada — o conteúdo não foi partilhado consigo.',
  evidenceHeading: 'Provas',
  evidenceNone: 'Não foram anexadas provas. Avalie o motivo acima por si só.',
  changeAdded: 'Adicionado',
  changeRemoved: 'Removido',
  changeChanged: 'Alterado',
  changeUnchanged: 'Sem alterações',
  moreLineCount: 'one:linha a mais|other:linhas a mais',
  moreUnchangedLineCount: 'one:linha sem alterações a mais|other:linhas sem alterações a mais',
  unchangedLineCount: 'one:linha sem alterações|other:linhas sem alterações',
  skipAdded: '{lines} — visíveis na revisão completa',
  skipRemoved: '{lines} removidas',
  cutUnchanged: '{lines} não apresentadas',
  cutChanged: '{lines} não apresentadas, {changes}. Verifique-as na revisão completa.',
  cutAddedRemoved: '{added} adicionadas e {removed} removidas',
  cutAdded: '{added} adicionadas',
  cutRemoved: '{removed} removidas',
  lineAddedSr: 'Adicionado:',
  lineRemovedSr: 'Removido:',
  noLinesAdded: 'Uma secção nova. O texto está na revisão completa abaixo.',
  noLinesRemoved: 'Esta secção seria removida da página.',
  noLinesChanged: 'Esta secção muda. O texto está na revisão completa abaixo.',
  diffHeading: 'Alterações',
  outcomeArchived: 'Arquivada.',
  outcomeArchivedBody:
    '{title} já não informa as respostas e saiu da lista de páginas. As revisões, esta sugestão e a decisão ficam no histórico da página.',
  openArchivedPage: 'Abrir a página arquivada',
  outcomeApproved: 'Aprovada.',
  outcomeApprovedRevision: 'A revisão {n} é agora a versão aprovada de {title}.',
  outcomeApprovedPlain: 'Esta sugestão foi aprovada.',
  outcomeRestored: 'A página voltou à lista de páginas e volta a informar as respostas.',
  outcomeKept: 'A sugestão, a decisão e todas as revisões anteriores ficam no histórico da página.',
  openPage: 'Abrir a página',
  outcomeDismissed: 'Descartada.',
  outcomeWithdrawn: 'Retirada.',
  outcomeSuperseded: 'Substituída.',
  outcomeSupersededBody:
    'Uma revisão, sugestão ou importação do repositório mais recente tornou esta sugestão obsoleta. Por si só, não alterou nada.',
  outcomeUnchanged: 'A página fica como está.',
  approveNewPage: 'Aprovar a página nova',
  approveArchive: 'Aprovar o arquivo',
  approveRestoreRevision: 'Restaurar e aprovar a revisão {n}',
  approveRevision: 'Aprovar a revisão {n}',
  approveArchiveNote: 'Ao aprovar, esta página é arquivada para todos na empresa {company}.',
  approvePublishNote: 'Ao aprovar, esta revisão é publicada para todos na empresa {company}.',
  approvePublishEvidenceNote:
    'Ao aprovar, esta revisão e os excertos de provas apresentados acima são publicados para todos na empresa {company}.',
  archivedTitle: 'Esta página está arquivada.',
  alreadyArchivedBody: 'Aprovar não alteraria nada, por isso esta sugestão só pode ser descartada.',
  archivedRestoreBody:
    'Ao aprovar, a página é restaurada: volta à lista de páginas, à pesquisa e às respostas com esta revisão.',
  staleRevisionAction: 'Comparar com a versão mais recente',
  staleProposalTitle: 'Esta sugestão mudou enquanto a estava a rever.',
  staleProposalAction: 'Rever a versão mais recente',
  staleArchivedTitle:
    'Esta página foi arquivada enquanto a estava a rever. Aprovar esta sugestão iria restaurá-la.',
  staleArchivedAction: 'Rever novamente',
  suggestionMissingTitle: 'Esta sugestão não está disponível.',
  suggestionMissingBody:
    'Pode ter sido retirada, ou pertence a outra pessoa e não foi enviada para revisão da empresa.',
  decideUnconfirmed:
    'Não foi possível confirmar a sua decisão. O estado apresentado é o mais recente do Poneva; verifique-o antes de tentar novamente.',
  decideFailed: 'Não foi possível guardar a sua decisão.',
  discussPrompt:
    'Ajude-me a melhorar a atualização de conhecimento sugerida para «{title}» ({link}).',
  conflictBody:
    'Esta sugestão foi escrita com base na revisão {base}; a revisão atual é a {current}. Aprová-la substituiria essa alteração, por isso não pode ser aprovada tal como está.',
  conflictBodyPlain:
    'Esta sugestão foi escrita com base numa revisão anterior, por isso não pode ser aprovada tal como está.',
  openLatest: 'Abrir a versão mais recente',
  reworkInChat: 'Reformular no chat',
  factReason: 'Motivo',
  factNoReason: 'Não foi indicado nenhum motivo.',
  factAudience: 'Público',
  factRevision: 'Revisão',
  revisionNew: 'Uma página nova, revisão 1',
  revisionArchiveAfter: 'Arquivar após a revisão {n}',
  revisionWrittenAgainst: 'Escrita com base na revisão {base}; a revisão atual é a {current}',
  revisionCurrentToProposed: 'Revisão atual {base} → revisão proposta {next}',
  revisionProposed: 'Revisão proposta {next}',
  proposedPage: 'Página proposta',
  archivingHeading: 'O que faz o arquivo',
  archivingBody:
    'A página deixa de informar as respostas e sai da lista de páginas. As revisões e esta decisão são preservadas.',
  noComparison: 'Não está disponível uma comparação por secções para esta sugestão.',
  showComplete: 'Mostrar a revisão completa',
  approving: 'A aprovar…',
  dismissing: 'A descartar…',
  dismiss: 'Descartar',
  withdrawing: 'A retirar…',
  withdraw: 'Retirar',
  editInChat: 'Editar no chat',
  waitingForPublisher: 'A aguardar a revisão de um publicador da empresa.',
  snapshotTooLarge: 'Este snapshot tem mais de 8 MB. Crie-o com menos documentos.',
  snapshotNotSnapshot:
    'Este ficheiro não é um snapshot de conhecimento. Escolha o ficheiro JSON criado pelo script de snapshot.',
  snapshotEmpty: 'Este snapshot não contém documentos.',
  readDocumentFailed: 'Não foi possível ler este documento. Tente novamente.',
  readingDocument: 'A ler o documento…',
  hideText: 'Ocultar o texto',
  readText: 'Ler o texto',
  textOf: 'Texto de {title}',
  gitSnapshot: 'Snapshot Git {commit}',
  repositorySnapshot: 'Snapshot do repositório',
  importNewHeading: '{pages} · aprovadas ao aplicar',
  importNewNote:
    'Cada uma é publicada como página aprovada para todos em {company}, sem mais revisão. Leia cada uma antes de aplicar.',
  importChangedHeading: '{pages} · enviadas para revisão',
  importChangedNote:
    'Cada uma passa a ser uma atualização sugerida. A página só muda quando um publicador a aprova em Para rever, onde se vê o que mudou.',
  unchangedDocumentCount: 'one:documento sem alterações|other:documentos sem alterações',
  unchangedNote:
    'Estes já coincidem com as respetivas páginas aprovadas. Nada é escrito para eles.',
  stagedHeading: 'Preparadas mas não aplicadas',
  excludedSummary: '{documents} excluídos deste snapshot',
  countsLine: '{newPages} · {changedPages} para rever · {unchanged} sem alterações',
  importAlreadyDiscarded: 'Esta importação já foi descartada.',
  confirmLabel: 'Confirmar a importação',
  unchangedKeepCount:
    'one:documento sem alterações mantém a sua página|other:documentos sem alterações mantêm as suas páginas',
  confirmBody:
    'Aplicar esta importação para todos em {company}? {newPages} serão aprovadas como revisão 1, {changedPages} ficarão a aguardar revisão e {unchanged}. As sugestões de importações anteriores para estas páginas são retiradas.',
  applying: 'A aplicar…',
  applyImport: 'Aplicar a importação',
  chooseAnother: 'Escolher outro ficheiro',
  allCurrent: 'Tudo neste snapshot já está atualizado.',
  importApplied: 'Importação aplicada.',
  appliedSummary: '{pages} criadas · {changes} a aguardar revisão · {unchanged} sem alterações.',
  appliedIndexing:
    'As páginas novas ficam pesquisáveis no chat quando a indexação terminar. A preparação das fontes mostra o progresso.',
  openPages: 'Abrir as páginas',
  reviewChanges: 'Rever {changes}',
  checkIndexing: 'Verificar o progresso da indexação',
  sendSnapshotFailed: 'Não foi possível enviar este snapshot. Tente novamente.',
  openStagedFailed: 'Não foi possível abrir esta importação preparada.',
  applyUnconfirmed:
    'Não foi possível confirmar se a importação foi aplicada. Verifique Páginas antes de tentar novamente.',
  applyFailed: 'Não foi possível aplicar esta importação.',
  importHeading: 'Importar páginas do repositório',
  backToPages: 'Voltar às páginas',
  importLead:
    'Crie um snapshot com {command} e, em seguida, escolha o ficheiro. Verá cada documento e o que alteraria antes de qualquer coisa ser guardada.',
  snapshotFileLabel: 'Ficheiro do snapshot de conhecimento',
  readingSnapshot: 'A ler o snapshot…',
  openingStaged: 'A abrir a importação preparada…',
  chooseSnapshot: 'Escolher o ficheiro do snapshot',
  factOrigin: 'Origem',
  factContents: 'Conteúdo',
  importOnlyListed: 'Só são importados os documentos aqui listados.',
  importRepositoryAuthoritative:
    'O repositório continua a ser a referência; os documentos alterados passam a ser sugestões para revisão.',
  overviewReviewChanges: 'Rever alterações',
  overviewConnectAgents: 'Ligar agentes externos',
  overviewEyebrow: 'Um conhecimento partilhado',
  overviewTitle: '{company}, em contexto.',
  overviewLeadFallback:
    'O conhecimento da sua empresa começa com o contexto que partilha. Construam juntos uma compreensão do seu negócio.',
  overviewBody:
    'O contexto da empresa e o material de origem dão ao Poneva um ponto de partida — não tudo o que há a saber sobre {company}. Continue a desenvolver este conhecimento à medida que o seu negócio evolui.',
  overviewAskPrompt: 'O que sabe sobre a nossa empresa e o que seria útil acrescentar?',
  overviewAsk: 'Perguntar sobre {company}',
  overviewAddSources: 'Adicionar fontes',
  contextEyebrow: 'O que dá contexto às respostas',
  contextTitle: 'O negócio por detrás da pergunta.',
  contextBody:
    'As fontes de sites explicam o lado público do negócio. As notas da empresa acrescentam a sua terminologia, as suas prioridades e a forma como trabalha.',
  contextPrompt:
    'Ajude-me a clarificar as prioridades da empresa e as preferências de trabalho que devemos memorizar.',
  contextAction: 'Construir o nosso conhecimento',
  learnEyebrow: 'Espaço para aprender',
  learnTitle: 'Comece pelo que importa a seguir.',
  learnBody:
    'Traga material de origem ou clarifique como a sua empresa trabalha. O Poneva pode sugerir alterações duradouras para rever.',
  learnPrompt:
    'Com base no conhecimento atual da nossa empresa, que informações importantes faltam para o trabalho que queremos fazer?',
  learnAction: 'Discutir o que seria útil',
  canvasEmptyTitle: 'Um pouco de contexto faz toda a diferença.',
  canvasEmptyBody:
    'O perfil da sua empresa é o ponto de partida. Adicione material de origem e notas revistas para ajudar o Poneva a compreender o seu trabalho.',
  pageEyebrow: 'Espaço de trabalho de {company}',
  pageTitle: 'Conhecimento da empresa',
  pageDescription: 'As fontes e o conhecimento por trás do trabalho do Poneva.',
  tabOverview: 'Visão geral',
  tabPages: 'Páginas',
  tabSources: 'Fontes',
  tabReview: 'Para rever',
  proposalApproved: 'Contexto da empresa aprovado',
  proposalDismissed: 'Sugestão descartada',
  proposalRemoval: 'Remoção proposta',
  proposalCorrection: 'Correção proposta',
  proposalContext: 'Contexto da empresa proposto',
  proposalCurrent: 'Conhecimento atual',
  proposalFactGone:
    'O facto guardado já não está disponível. Atualize o conhecimento da empresa antes de rever esta remoção.',
  proposalReviewFallback: 'Reveja o contexto da empresa proposto.',
  proposalNotSaved: 'Ainda não guardado. As fontes originais permanecem inalteradas.',
  proposalWaiting: 'A aguardar revisão · um publicador decide na sua Caixa de entrada',
  proposalSaving: 'A guardar…',
  proposalApproveRemoval: 'Aprovar remoção',
  proposalApproveClarification: 'Aprovar clarificação',
  factLabel: 'Facto da empresa',
  factEyebrow: 'Facto · Todos em {company}',
  factSuggestCorrection: 'Sugerir uma correção',
  factAskPrompt:
    'Ajude-me a compreender ou clarificar este contexto da empresa guardado: «{content}»',
  factAsk: 'Perguntar sobre isto',
  companyContextHeading: 'Contexto da empresa',
  companyContextPrompt:
    'Gostaria de clarificar o conhecimento da nossa empresa. Ajude-me a rever o que sabemos e a propor uma atualização.',
  companyContextEmpty:
    'Ainda não há notas aprovadas. Inicie uma conversa sobre a sua empresa ou adicione material de origem abaixo.',
  refineInChat: 'Refinar no chat',
  reviewPanelLabel: 'Alterações ao conhecimento para rever',
  suggestedUpdatesHeading: 'Atualizações sugeridas',
  suggestedUpdatesIntro:
    'Sugestões das suas conversas. Cabe-lhe a si decidir o que passa a fazer parte do conhecimento duradouro da sua empresa.',
  reviewEmptyTitle: 'Não há nada a aguardar a sua revisão.',
  reviewEmptyBody:
    'Quando o Poneva sugerir uma alteração ao conhecimento da sua empresa, encontra-a aqui. As alterações duradouras precisam sempre da sua aprovação.',
  reviewEmptyPrompt:
    'Ajude-me a rever o conhecimento da nossa empresa e sugira o que seria útil clarificar a seguir.',
  inclusionPendingApproval: 'Alteração de inclusão no conhecimento enviada para aprovação.',
  sourcesFileIncluded: 'Ficheiro incluído na pesquisa de conhecimento para o público atual.',
  sourcesAddFailed: 'Não foi possível adicionar esta fonte.',
  sourcesHeading: 'O material por trás das respostas.',
  sourcesIntro:
    'O Poneva pesquisa todo o material de origem, não apenas a visão geral. Mantenha os originais, veja o que está pronto e escolha o que fundamenta as suas respostas.',
  addSourceHeading: 'Adicionar material da sua empresa',
  addSourceIntro:
    'As fontes carregadas ficam privadas na sua Biblioteca e só informam as suas próprias respostas. Escolha Partilhar quando quiser disponibilizá-las aos colegas.',
  uploadSource: 'Carregar uma fonte',
  addSourcePrompt:
    'Ajude-me a adicionar uma declaração da empresa como fonte interna partilhada. Pergunte-me o que quero registar; não invente nenhum conteúdo. As alterações duradouras ao conhecimento da empresa continuam a precisar da minha aprovação.',
  addThroughChat: 'Adicionar pelo chat',
  addingSource: 'A adicionar…',
  addToKnowledge: 'Adicionar ao conhecimento',
  uploadFormats: 'TXT, Markdown, CSV e JSON · Até 5 MB por ficheiro',
  sourceExcluded: 'Excluída das respostas',
  sourcePreparationFailed: 'A preparação falhou',
  sourcePreparing: 'A preparar para pesquisa',
  sourceWaiting: 'A aguardar preparação',
  sourceReadinessUnknown: 'Estado de preparação indisponível',
  sourceRetryQueued: 'Preparação em fila. O estado será atualizado quando terminar.',
  sourceIncludedNotice: 'Fonte incluída. O Poneva vai prepará-la para pesquisa.',
  sourceExcludedNotice: 'Excluída das respostas. A fonte original é mantida.',
  sourceUpdateFailed: 'Não foi possível atualizar esta fonte.',
  sourceOriginalMaterial: 'Material original da fonte',
  sourceDiscuss: 'Discutir no chat',
  sourceDiscussPrompt: 'Ajude-me a compreender ou clarificar «{title}».',
  sourceExclude: 'Excluir das respostas',
  sourceInclude: 'Incluir nas respostas',
  sourcesLoadFailed: 'Não foi possível carregar as suas fontes.',
  sourceLibraryLabel: 'Biblioteca de fontes da empresa',
  sourceListCaption: 'Fontes originais · incluídas e excluídas',
  sourceSearchLabel: 'Pesquisar fontes da empresa',
  sourceSearchPlaceholder: 'Pesquisar as suas fontes…',
  sourcesFinding: 'A procurar as suas fontes…',
  sourcePagesLabel: 'Páginas de fontes',
  sourceRange: '{from}–{to} de {count}',
  sourceCount: 'one:fonte|other:fontes',
  sourcePrevious: 'Anterior',
  sourceNext: 'Seguinte',
  sourceNoMatchTitle: 'Nenhuma fonte corresponde.',
  sourceNoMatchBody: 'Experimente outra expressão ou outro nome de fonte.',
  sourceEmptyTitle: 'Dê às suas perguntas um ponto de partida mais sólido.',
  sourceEmptyBody:
    'Adicione documentos da empresa, dados de produtos ou notas de trabalho. O Poneva pode usar todo o material de origem nas conversas e nas Skills.',
  indexCheckFailed: 'Não foi possível verificar a preparação das fontes.',
  indexRetryQueued:
    'As entradas de conhecimento que falharam foram colocadas em fila para preparação. O seu material de origem não foi alterado.',
  indexQueueFailed: 'Não foi possível colocar a preparação em fila. Tente novamente.',
  indexPreparing: 'A preparar novo conhecimento para as suas conversas…',
  indexAttention: 'Algum conhecimento precisa de atenção.',
  queuing: 'A colocar em fila…',
  retryPreparation: 'Repetir a preparação',
  sourceKindStatement: 'Declaração da empresa',
  sourceKindWebsite: 'Site',
  sourceKindDocument: 'Documento',
  factAnswers: 'one:resposta|many:respostas|other:respostas',
  factUsedThisWeek: 'Utilizado em {answers} esta semana',
  factLastUsed: 'última utilização: {when}',
  factToday: 'hoje',
  factYesterday: 'ontem',
  factImpact: 'Esta alteração afeta um facto utilizado em {answers} esta semana.',
  factCorrectionAbout: 'Sobre este facto da empresa: «{content}» ({link})',
  factCorrectionOutdated: 'Isto está desatualizado:',
  sourceCanvasRecorded: 'Material de origem registado',
  sourceCanvasNotIncluded:
    'Não incluído no conhecimento da empresa. O original é mantido para referência e ainda pode ser utilizado numa conversa específica.',
  sourceCanvasOpenOriginal: 'Abrir a fonte original',
  sourceCanvasUnavailable: 'O conteúdo da fonte não está disponível.',
  sourceCanvasDiscussPrompt: 'Ajude-me a compreender ou esclarecer «{title}».',
  sourceCanvasDiscuss: 'Discutir esta fonte',
  sourceCanvasCorrectionNote:
    'Uma correção passa a ser contexto da empresa proposto. A fonte registada mantém-se inalterada.',
  contextCanvasEyebrow: 'Contexto da empresa disponível',
  contextCanvasTitle: 'O conhecimento por trás desta conversa.',
  contextCanvasBody:
    'Conhecimento aprovado e o material de origem que a sua empresa adicionou. Disponível no chat e em Skills.',
  contextCanvasOpen: 'Abrir Conhecimento',
};

export default pt;
